import { Input } from "@/components/ui/input";
import { MapPin } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useState } from "react";

interface PreferredDestinationsProps {
  destinations: string[];
  onChange: (destinations: string[]) => void;
}

export const PreferredDestinations = ({ destinations, onChange }: PreferredDestinationsProps) => {
  const [input, setInput] = useState("");

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && input.trim()) {
      e.preventDefault();
      const newDestination = input.trim();
      if (!destinations.includes(newDestination)) {
        onChange([...destinations, newDestination]);
      }
      setInput("");
    }
  };

  const removeDestination = (destination: string) => {
    onChange(destinations.filter(d => d !== destination));
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <MapPin className="h-4 w-4" />
        <label className="text-sm font-medium">Preferred Destinations</label>
      </div>
      
      <div className="flex flex-wrap gap-2 mb-2">
        {destinations.map((destination) => (
          <Badge 
            key={destination}
            variant="secondary"
            className="cursor-pointer hover:bg-destructive hover:text-destructive-foreground"
            onClick={() => removeDestination(destination)}
          >
            {destination} ×
          </Badge>
        ))}
      </div>

      <Input
        placeholder="Type a destination and press Enter"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};